import { render } from "./Logo.vue?vue&type=template&id=dfd28cfa&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=dfd28cfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd28cfa"]])

export default __exports__